import type { CSSObject } from "type/tss";

export const styles = () => ({
	stack: {
		display: "flex",
		flexDirection: "column",
		alignItems: "flex-start",
		gap: 4,
	},
} satisfies Record<string, CSSObject>);
